import { render } from "./HeroSection.vue?vue&type=template&id=f1aaa464&scoped=true"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=f1aaa464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1aaa464"]])

export default __exports__